import { Inject, Injectable } from '@angular/core';
import { LoadersService } from '../utils/loaders/loaders.service';
import { LoaderActions } from '../utils/loaders/loader-actions.enum';
import { LoaderManagement } from '../utils/loaders/loader-management';
import { ModalLoaderData } from '../utils/loaders/modal-loader.service';
import { MsisdnFormat } from '../utils/pipes/msisdnFormat';
import { CommonModalService } from '../utils/modals/common-modal.service';
import { CommonModalTemplatesEnum } from '../utils/modals/common-modal-templates.enum';

@Injectable({
  providedIn: 'root'
})
export class BundleDetailsModalService {
  constructor(
    @Inject('Endpoint') private endpoint: any,
    private commonModalService: CommonModalService,
    private loadersService: LoadersService,
  ) {
  }

  public showDetailsModal(_deviceId: string, _msisdn: string = null) {
    if (_deviceId) {
      this.sendRequest(_deviceId, _msisdn);
    }
  }

  private sendRequest(deviceId: string, msisdn: string): void {
    this.startLoader();
    this.endpoint('newCart.bundleItemsDetails')
      .requestData ({
        productId: deviceId
      })
      .queue()
      .run()
      .then((response: any) => {
        this.stopLoader().runAfterDelay(() => {
          this.openModal(response, msisdn);
        });
      })
      .catch(() => {
        this.stopLoader();
      });
  }

  private openModal(_response: any, _msisdn: string): void {
    const msisdn = new MsisdnFormat().transform(_msisdn);

    const modalData = {
      templateName: CommonModalTemplatesEnum.SLOT_DETAILS_MODAL,
      devices: _response,
      msisdn: msisdn
    };

    this.commonModalService.setData(modalData);
  }

  private startLoader(): void {
    const loaderText: string = 'Ładuję szczegóły oferty';

    this.loadersService.start(
      LoaderActions.MODAL_LOADER,
      new ModalLoaderData(
        loaderText,
        true
      ),
      true
    );
  }

  private stopLoader(): LoaderManagement {
    return this.loadersService.stop(LoaderActions.MODAL_LOADER);
  }
}
